/**
 * @Author: wuyang
 * @Date: 2024/1/11
 * @Description: ""
 */
export enum EBizPhone {
	real = 0,      // 真人图  0
	mannequin = 1, // 人台图  1
	goods = 2,     // 商品图 2
	wig = 3,       // 假发图 3
	texture = 4,   // 纹理图 4
  tabularasa = 5, // 白板图 5
}

export type TBizPhone = keyof typeof EBizPhone
